
const Footer = () => {
  const currentYear = new Date().getFullYear();

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <footer className="bg-gradient-to-br from-[#1B3A5F] to-[#2A4A6F] text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          <div>
            <img
              src="https://static.readdy.ai/image/fbd6e293aff082c6551014a76550a28a/5a24b8589528981ca1e7e6ecacc1742d.png"
              alt="Finance Planning Wealth Logo"
              className="h-12 w-auto mb-6 opacity-95 drop-shadow-md"
            />
            <p className="text-white/80 text-sm leading-relaxed mb-6">
              Expert financial planning and wealth management services tailored to your unique goals and aspirations.
            </p>
          </div>

          <div>
            <h3 className="text-lg font-bold mb-6">Quick Links</h3>
            <ul className="space-y-3">
              <li>
                <button
                  onClick={() => scrollToSection('hero')}
                  className="text-white/80 hover:text-[#F5A623] transition-colors text-sm cursor-pointer"
                >
                  Home
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('services')}
                  className="text-white/80 hover:text-[#F5A623] transition-colors text-sm cursor-pointer"
                >
                  Services
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('about')}
                  className="text-white/80 hover:text-[#F5A623] transition-colors text-sm cursor-pointer"
                >
                  About Us
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('approach')}
                  className="text-white/80 hover:text-[#F5A623] transition-colors text-sm cursor-pointer"
                >
                  Our Approach
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('faq')}
                  className="text-white/80 hover:text-[#F5A623] transition-colors text-sm cursor-pointer"
                >
                  FAQ
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-bold mb-6">Services</h3>
            <ul className="space-y-3">
              <li>
                <button
                  onClick={() => scrollToSection('services')}
                  className="text-white/80 hover:text-[#F5A623] transition-colors text-sm cursor-pointer"
                >
                  Wealth Management
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('services')}
                  className="text-white/80 hover:text-[#F5A623] transition-colors text-sm cursor-pointer"
                >
                  Retirement Planning
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('services')}
                  className="text-white/80 hover:text-[#F5A623] transition-colors text-sm cursor-pointer"
                >
                  Estate Planning
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('services')}
                  className="text-white/80 hover:text-[#F5A623] transition-colors text-sm cursor-pointer"
                >
                  Risk Management
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('services')}
                  className="text-white/80 hover:text-[#F5A623] transition-colors text-sm cursor-pointer"
                >
                  Business Planning
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-bold mb-6">Contact Info</h3>
            <ul className="space-y-4">
              <li className="flex items-start">
                <i className="ri-phone-line text-[#F5A623] mt-1 mr-3"></i>
                <div>
                  <p className="text-white/80 text-sm">Phone</p>
                  <a href="tel:02083201450" className="text-white hover:text-[#F5A623] text-sm font-medium">
                    01444 449 200
                  </a>
                </div>
              </li>
              <li className="flex items-start">
                <i className="ri-mail-line text-[#F5A623] mt-1 mr-3"></i>
                <div>
                  <p className="text-white/80 text-sm">Email</p>
                  <a href="mailto:wealth@financeplanning.co.uk" className="text-white hover:text-[#F5A623] text-sm font-medium">
                    wealth@financeplanning.co.uk
                  </a>
                </div>
              </li>
              <li className="flex items-start">
                <i className="ri-time-line text-[#F5A623] mt-1 mr-3"></i>
                <div>
                  <p className="text-white/80 text-sm">Mon - Fri: 9:00 AM - 5:00 PM</p>
                </div>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8 mb-8">
          <p className="text-white/70 text-xs leading-relaxed mb-4">
            Our services relate to certain investments whose prices are dependent on fluctuations in the financial markets beyond our control. Investments and the income from them may go down as well as up and you may get back less than the amount invested. Past performance cannot be used as a reliable prediction of future performance.
          </p>
          <p className="text-white/70 text-xs leading-relaxed">
            Finance Planning Wealth Ltd is an Appointed Representative of New Leaf Distribution Ltd which is authorised and regulated by the Financial Conduct Authority: FCA Number 460421.
          </p>
        </div>

        <div className="border-t border-white/10 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-white/60 text-sm text-center md:text-left">
              © {currentYear} Finance Planning Wealth. All rights reserved.
            </p>
            <div className="flex items-center space-x-6">
              <a href="/privacy" className="text-white/60 hover:text-[#F5A623] text-sm transition-colors">
                Privacy Policy
              </a>
              <a href="/complaints" className="text-white/60 hover:text-[#F5A623] text-sm transition-colors">
                Complaints Procedure
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
